import { createSlice, PayloadAction } from '@reduxjs/toolkit'

export interface RouterState {
  navigatePath: string | undefined
  delay: number | undefined
}

const initialState: RouterState = {
  navigatePath: undefined,
  delay: 0,
}

const routerSlice = createSlice({
  name: 'router',
  initialState,
  reducers: {
    naviagePath: (state, action: PayloadAction<RouterState>) => {
      return {
        ...state,
        ...action.payload,
      }
    },
    clearNavigatePath: (state) => {
      return {
        ...state,
        navigatePath: undefined,
      }
    },
  },
})

export const { naviagePath, clearNavigatePath } = routerSlice.actions
export default routerSlice
